import { useRequiredContext } from "@redotech/react-util/context";
import { useHandler } from "@redotech/react-util/hook";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Card } from "@redotech/redo-web/card";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useState } from "react";
import { RedoAdminRpcClientContext } from "../../../app/redo-admin-rpc-client-provider";

export const MigrateToSupportV2Card = memo(function MigrateToSupportV2Card({
  teamId,
}: {
  teamId: string;
}) {
  const rpcClient = useRequiredContext(RedoAdminRpcClientContext);
  const [pending, setPending] = useState(false);
  const [workflowId, setWorkflowId] = useState<string | undefined>();
  const [error, setError] = useState<string | undefined>();

  const handleMigrate = useHandler(async () => {
    setPending(true);
    setError(undefined);
    setWorkflowId(undefined);
    try {
      const result = await rpcClient.migrateTeamToSupportV2({ teamId });
      setWorkflowId(result.workflowId);
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
    } finally {
      setPending(false);
    }
  });

  return (
    <Card radius="sm" title="Migrate team to support-v2">
      <Flex dir="column" gap="md" w="full">
        <Text fontSize="sm">
          Migrates all team data (integrations, tags, conversations) from
          MongoDB to CockroachDB (support-v2). This kicks off a background
          Temporal workflow — you can track progress in the Temporal dashboard.
        </Text>
        <Flex align="center" gap="md">
          <RedoButton
            disabled={pending}
            hierarchy="primary"
            onClick={handleMigrate}
            pending={pending}
            text="Start migration"
          />
          {workflowId && (
            <Text fontSize="sm" fontWeight="medium">
              Started: {workflowId}
            </Text>
          )}
          {error && (
            <Text fontSize="sm" fontWeight="medium" textColor="error">
              Error: {error}
            </Text>
          )}
        </Flex>
      </Flex>
    </Card>
  );
});
